import { isUuid, RoleplayError, type Catalogue } from "./contract";
import { ROLEPLAY_GAME_KEY } from "./genesis";

export const ROLEPLAY_PATH = "/grow/play/roleplay";

export function gameHref(gameId: string): string {
  if (!isUuid(gameId)) throw new RoleplayError("ROLEPLAY_INVALID_INPUT");
  return `${ROLEPLAY_PATH}?game=${encodeURIComponent(gameId)}`;
}

export type UnavailableReason = "no_scenario" | "suspended";
export type GameEntry = { kind: "continue"; gameId: string } | { kind: "start" } |
  { kind: "unavailable"; reason: UnavailableReason };

export function gameEntry(catalogue: Catalogue): GameEntry {
  const game = catalogue.games.find((entry) => entry.gameKey === ROLEPLAY_GAME_KEY);
  if (game?.story) return { kind: "continue", gameId: game.story.id };
  if (game?.available) return { kind: "start" };
  return { kind: "unavailable", reason: game?.unavailable === "suspended" ? "suspended" : "no_scenario" };
}

export function earliestExpiry(catalogue: Catalogue): string | null {
  const date = catalogue.games.find((entry) => entry.gameKey === ROLEPLAY_GAME_KEY)?.story?.expiresAt;
  return date && !Number.isNaN(Date.parse(date)) ? date : null;
}
